import LanguageSelect from "app/components/LanguageSelector/LanguageSelect";
import OddsSelector from "app/components/OddsSelector/OddsSelector";
import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import { UpdateOddsHelper } from "app/helpers/updateOddsHelper";
import "app/partials/FinanceSummary/FinanceSummary.scss";
import { CompetitionType } from "app/types/competitionType";
import type { UserType } from "app/types/userType";
import { OddsType } from "app/utils/const";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./PublicViewOptions.scss";

type Props = {
  loadUser: Function;
  user: UserType;
  pollingAccount: boolean;
  isIdle: boolean;
  sessionView: string;
  oddsOptions: { label: string; value: string }[];
  competitionList: CompetitionType[];
  competitionListTotal: number;
  competitionListOffset: number;
  resetCompetitions: Function;
  setCompetitions: Function;
  onLanguageChangeRequest: Function;
};

const PublicViewOptions: React.FC<Props> = props => {
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const [intervalId, setIntervalId] = useState<number>(0);
  const [intervalStarted, setIntervalStarted] = useState(false);
  const [selectedSessionView, setSelectedSessionView] = useState<string>(
    props.sessionView
  );
  const [selectedOddsType, setSelectedOddsType] = useState<string>(
    OddsType.DECIMAL
  );

  useEffect(() => {
    props.loadUser();
  }, []);

  useEffect(() => {
    const { user } = props;
    if (
      user.preferences !== undefined &&
      user.preferences.oddsType !== selectedOddsType
    ) {
      setSelectedOddsType(user.preferences.oddsType);
    }
  }, [props.user]);

  const startIntervalFetchAccount = () => {
    if (!intervalStarted) {
      const id = setInterval(() => {
        if (props.isIdle) return;
        props.loadUser();
      }, 60000);
      setIntervalId(id);
      setIntervalStarted(true);
    }
  };

  const endIntervalFetchEvent = () => {
    clearInterval(intervalId);
    setIntervalStarted(false);
  };

  useEffect(() => {
    startIntervalFetchAccount();
    return () => {
      endIntervalFetchEvent();
    };
  }, []);

  const handleChangeOddsType = () => {
    const { competitionList, resetCompetitions, setCompetitions } = props;
    if (competitionList.length > 0) {
      resetCompetitions();
    }
    setCompetitions();
  };

  const updateOdds = (odds: string) => {
    UpdateOddsHelper.updateOdds(odds, handleChangeOddsType);
  };

  const { oddsOptions, onLanguageChangeRequest } = props;

  return (
    <div className={`public-view-options public-view`}>
      <div className={`public-view--mobile`}>
        {oddsOptions && (
          <div className={"public-view-odds__dropdown"}>
            <OddsSelector
              oddsOptions={oddsOptions}
              updateOdds={updateOdds}
              selectedOdds={selectedOddsType}
              disabled={false}
            />
          </div>
        )}
        <div className="language__input--row">
          <LanguageSelect
            onLanguageChangeRequest={onLanguageChangeRequest}
            locale={LanguageSelectionHelper.checkSelectedLanguage()}
            small={true}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.userModel.user,
  isIdle: state.sessionModel.isIdle,
  sessionView: state.sessionModel.view,
  oddsOptions: state.competitionListModel.oddsOptions,
  competitionList: state.competitionListModel.competitionList,
  competitionListTotal: state.competitionListModel.competitionListTotal,
  competitionListOffset: state.competitionListModel.competitionListOffset,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
  resetCompetitions: (type: string) => {
    dispatch.competitionListModel.resetCompetition();
  },
  setCompetitions: () => {
    dispatch.competitionListModel.setEuroCompetitionList();
  },
  onLanguageChangeRequest: (lang: string) => {
    dispatch.profileModel.onLanguageChange(lang);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicViewOptions);
